module.exports = __webpack_public_path__ + "img/VetoSans-LightItalic.69b7d032.svg";